import React from "react";
import { computeIndexOfLastItemInPage } from "./pagination.helper";
import { PaginationProps } from "./pagination.types";

/**
 * All props are required because the default props have been set in the parent
 */
export interface PaginationSummaryProps {
  startIndex: number;
  resultsCount: number;
  pageSize: number;
  generateRowTextFn: Required<PaginationProps>["customResultsSummaryFn"];
  resultsLabel: string;
  resultLabel: string;
  ofTextLabel: string;
}

export const ResultsSummary = ({
  startIndex,
  resultsCount,
  pageSize,
  generateRowTextFn,
  resultsLabel,
  resultLabel,
  ofTextLabel,
}: PaginationSummaryProps): React.ReactElement | null => {
  /*
   * Compute start and end index for displays
   */
  const startIndexForDisplay = startIndex + 1;
  const lastIndexForDisplay = computeIndexOfLastItemInPage(
    startIndex,
    pageSize,
    resultsCount
  );

  return (
    <div className="spark-pagination__summary">
      {generateRowTextFn({
        from: startIndexForDisplay,
        to: lastIndexForDisplay,
        count: resultsCount,
        resultsLabel: resultsLabel,
        resultLabel: resultLabel,
        ofTextLabel: ofTextLabel,
      })}
    </div>
  );
};
